export { ScrollAreaRoot as Root } from "./root/ScrollAreaRoot.js";
export { ScrollAreaViewport as Viewport } from "./viewport/ScrollAreaViewport.js";
export { ScrollAreaScrollbar as Scrollbar } from "./scrollbar/ScrollAreaScrollbar.js";
export { ScrollAreaContent as Content } from "./content/ScrollAreaContent.js";
export { ScrollAreaThumb as Thumb } from "./thumb/ScrollAreaThumb.js";
export { ScrollAreaCorner as Corner } from "./corner/ScrollAreaCorner.js";